<template>
  <v-layout row wrap mb-5>
    <v-flex xs12 class="text-xs-center pages-title"><h1>{{ $t('pages.predict') }}</h1></v-flex>
    <v-flex xs12 mb-5 class="text-xs-center">
      <v-progress-circular :size="50" indeterminate color="primary" v-if="gamesLoading"></v-progress-circular>
      <v-tabs
        show-arrows
        v-model="activeTour"
        grow
        class="game-tabs"
        v-if="activeTour"
      >
        <v-tabs-slider></v-tabs-slider>
        <v-tab
          v-for="tour in tours"
          :key="tour._id"
          :href="'#tab-' + tour._id"
          :disabled="!tour.isActive"
        >
          {{ tour.name[Vue.$i18n.locale] }}
        </v-tab>
        <v-tabs-items touchless>
          <v-tab-item
            :transition="false"
            :reverse-transition="false"
            v-for="tour in tours"
            :key="tour._id"
            :id="'tab-' + tour._id"
            mt-4
          >
            <v-flex xs12>
                <v-layout row wrap
                          justify-center
                          predict-games-list
                >
                  <v-flex d-flex lg3 md4 sm6 xs12
                          class="text-xs-center"
                          v-for="game in tour.games"
                          :key="game._id"
                  >
                    <v-card class="game-card">
                      <v-card-title>
                        {{ toDate(game.startDate) }}
                      </v-card-title>
                      <v-card-text>
                        <div class="game-start">{{ gameStatus(game) }}</div>
                        <v-flex xs12>
                          <v-layout row fill-height class="game-layout">
                            <v-flex xs4>
                              <span :class="gameFlag(game.firstCountry.fifaCode)"></span>
                              <span class="country-name">{{ game.firstCountry.name[Vue.$i18n.locale] }}</span>
                            </v-flex>
                            <v-flex xs4>
                              <v-layout row>
                                <v-flex xs4 md6 lg5 xl4 @click="verifyAuth(game.isFinished, game.startDate)">
                                  <v-text-field
                                    v-if="game.isFinished"
                                    type="number"
                                    class="game-score"
                                    disabled
                                    :value="game.firstScore"
                                  >
                                  </v-text-field>
                                  <v-text-field
                                    v-else-if="new Date(game.startDate).getTime() < Date.now()"
                                    type="number"
                                    class="game-score"
                                    disabled
                                    :value="loadScore(game._id, 'firstScore')"
                                  ></v-text-field>
                                  <v-text-field
                                    v-else
                                    type="number"
                                    min="0"
                                    max="99"
                                    class="game-score"
                                    :disabled="Vue.$store.state.userData.points === 'none'"
                                    @keyup="predictScore(game._id, $event.target.value, 'firstScore')"
                                    :value="loadScore(game._id, 'firstScore')"
                                  ></v-text-field>
                                </v-flex>
                                <v-flex xs4 md4 lg4 xl4>
                                  <v-icon class="game-icon">remove</v-icon>
                                </v-flex>
                                <v-flex xs4 md6 lg5 xl4 @click="verifyAuth(game.isFinished, game.startDate)">
                                  <v-text-field
                                    v-if="game.isFinished"
                                    type="number"
                                    class="game-score"
                                    disabled
                                    :value="game.secondScore"
                                  >
                                  </v-text-field>
                                  <v-text-field
                                    v-else-if="new Date(game.startDate).getTime() < Date.now()"
                                    type="number"
                                    class="game-score"
                                    disabled
                                    :value="loadScore(game._id, 'secondScore')"
                                  ></v-text-field>
                                  <v-text-field
                                    v-else
                                    type="number"
                                    min="0"
                                    max="99"
                                    class="game-score"
                                    :disabled="Vue.$store.state.userData.points === 'none'"
                                    @keyup="predictScore(game._id, $event.target.value, 'secondScore')"
                                    :value="loadScore(game._id, 'secondScore')"
                                  ></v-text-field>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                            <v-flex xs4>
                              <span :class="gameFlag(game.secondCountry.fifaCode)"></span>
                              <span class="country-name">{{ game.secondCountry.name[Vue.$i18n.locale] }}</span>
                            </v-flex>
                          </v-layout>
                          <v-flex xs12>
                            <div class="game-label" v-if="Vue.$store.state.userData.points === 'none'">
                              {{ $t('game.needAuth') }}
                            </div>
                            <div class="game-label" v-else-if="game.isFinished">
                              <div class="game-label" v-if="Vue.$data.predicts[game._id]">
                                <div class="winner" v-if="Vue.$data.predicts[game._id].points > 0">
                                  <span v-if="Vue.$data.predicts[game._id].points === 1">
                                  {{$t('game.yourScore')}} &nbsp; <b>{{ Vue.$data.predicts[game._id].firstScore }} : {{ Vue.$data.predicts[game._id].secondScore }}</b>
                                    </span>
                                  <span v-else>
                                    {{$t('game.winner')}}
                                  </span>
                                  <div class="eMoney">
                                    +{{ Vue.$data.predicts[game._id].eMoney }}<img src="static/images/elei.svg" alt="" />
                                  </div>
                                </div>
                                <div v-else class="fail">
                                  {{$t('game.yourScore')}} &nbsp; <b>{{ Vue.$data.predicts[game._id].firstScore }} : {{ Vue.$data.predicts[game._id].secondScore }}</b>
                                  <div class="eMoney">
                                    +{{ Vue.$data.predicts[game._id].eMoney }}<img src="static/images/elei.svg" alt="" />
                                  </div>
                                </div>
                                <div class="label-points">+{{ Vue.$data.predicts[game._id].points }}</div>
                              </div>
                              <div v-else class="late" v-html="$t('game.toolate')"></div>
                            </div>
                            <div class="game-label" v-else-if="new Date(game.startDate).getTime() < Date.now()">
                              <div class="saved" v-if="Vue.$data.predicts[game._id]" v-html="$t('game.gotPredict')">
                              </div>
                              <div class="late" v-else v-html="$t('game.toolate')"></div>
                            </div>
                            <div class="game-label" v-else>
                              <div class="saved" v-if="Vue.$data.predicts[game._id]" v-html="$t('game.gotPredict')">
                              </div>
                              <div v-else>{{ $t('game.enterPredict') }}</div>
                            </div>
                          </v-flex>
                        </v-flex>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
            </v-flex>
          </v-tab-item>
        </v-tabs-items>
      </v-tabs>
    </v-flex>
<!--    <div class="ui-container home">-->
<!--      <div class="ui-grid ui-cols-1 ui-cols-2@s ui-gap" >-->
<!--        <div v-for="(item, idx) in products" :key="idx">-->
<!--          <div class="home-banner">-->
<!--           <div>-->
<!--             <h3 v-html="item.title[$i18n.locale]"></h3>-->
<!--             <p v-html="item.subtitle[$i18n.locale]"></p>-->
<!--             <div class="image">-->
<!--               <img :src="item.image" alt="">-->
<!--             </div>-->
<!--             <v-btn flat :href="item.url[$i18n.locale]" target="_blank">{{ $t('banners.btn') }}</v-btn>-->
<!--           </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
  </v-layout>
</template>

<script>
import Predict from '@/components/pages/ResultsPredict'
import PagesFunc from '@/components/pages'

export default {
  data () {
    return {
      gamesLoading: false,
      tours: [],
      activeTour: null,
      predicts: {},
      Vue: this,
      timer: ''
      // products: [
      //   {
      //     image: '/static/images/banners/1.png',
      //     title: {
      //       ro: 'Privește fotbalul<br> spectaculos',
      //       ru: 'Смотри футбол ярко'
      //     },
      //     subtitle: {
      //       ro: 'Alege-ți televizor',
      //       ru: 'Выбери себе телевизор'
      //     },
      //     url: {
      //       ro: 'https://enter.online/reduceri-la-televizoare/',
      //       ru: 'https://enter.online/ru/skidki-na-televizory/'
      //     }
      //   },
      //   {
      //     image: '/static/images/banners/2.png',
      //     title: {
      //       ro: 'Privește fotbal<br> la volum maxim',
      //       ru: 'Смотри футбол громко'
      //     },
      //     subtitle: {
      //       ro: 'Alege-ți soundbar',
      //       ru: 'Выбери себе саунбар'
      //     },
      //     url: {
      //       ro: 'https://enter.online/tehnica-audio/soundbar/',
      //       ru: 'https://enter.online/ru/audiotehnika/saundbary/'
      //     }
      //   },
      //   {
      //     image: '/static/images/banners/3.png',
      //     title: {
      //       ro: 'Antrenează-te cu<br> echipa preferată',
      //       ru: 'Тренируйся вместе<br>с любимой командой'
      //     },
      //     subtitle: {
      //       ro: 'Alege-ți smartwatch și brățară fitness',
      //       ru: 'Выбери себе умные часы и фитнес-браслет'
      //     },
      //     url: {
      //       ro: 'https://enter.online/gadgeturi/smart-watches-and-bracelets/',
      //       ru: 'https://enter.online/ru/gadzhety/smart-watches-and-bracelets/'
      //     }
      //   },
      //   {
      //     image: '/static/images/banners/4.png',
      //     title: {
      //       ro: ' Privește ziua fotbal,<br>joacă noaptea',
      //       ru: 'Смотри футбол днем,<br>играй ночью'
      //     },
      //     subtitle: {
      //       ro: 'Console gaming și accesorii',
      //       ru: 'Игровые консоли и аксессуарым'
      //     },
      //     url: {
      //       ro: 'https://enter.online/for-gamers/',
      //       ru: 'https://enter.online/ru/dlya-geymerov/'
      //     }
      //   },
      //   {
      //     image: '/static/images/banners/5.png',
      //     title: {
      //       ro: 'Privește fotbal<br> și savurează',
      //       ru: 'Смотри футбол вкусно'
      //     },
      //     subtitle: {
      //       ro: 'Alege-ți grill',
      //       ru: 'Выбери себе гриль'
      //     },
      //     url: {
      //       ro: 'https://enter.online/preparare-termica/gratare-electrice/',
      //       ru: 'https://enter.online/ru/prigotovlenie-pishi/electrogrily/'
      //     }
      //   }
      // ]
    }
  },
  methods: {
    toDate (time) {
      return new Date(time).toLocaleDateString(this.$i18n.locale, {
        day: 'numeric',
        month: 'long'
      })
    },
    gameStatus (game) {
      if (game.isFinished) return this.$t('game.finish')
      let startDate = new Date(game.startDate).getTime()
      if (startDate < Date.now()) return this.$t('game.start')
      return new Date(game.startDate).toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit'
      })
    },
    gameFlag (fifaCode) {
      if (fifaCode.length === 2) return `flag-icon flag-icon-${fifaCode}`
      return `flag flag-icon-${fifaCode}`
    },
    predictScore (id, score, country) {
      if (parseInt(score) < 0 || isNaN(score) || !score) return
      if (parseInt(score) > 99) {
        return this.$notice['warning']({
          title: this.$t('hack.warning'),
          description: this.$t('hack.tooLong')
        })
      }
      let obj = {
        gameId: id,
        country: country,
        score: score
      }
      Predict.saveScore(this, obj)
    },
    verifyAuth (finished, started) {
      if (finished || new Date(started).getTime() < Date.now()) return
      if (this.$store.state.userData.points === 'none') {
        return this.$notice['warning']({
          title: this.$t('auth.warning'),
          description: this.$t('auth.auth_to_save')
        })
      }
    },
    loadScore (id, country) {
      if (this.$data.predicts && this.$data.predicts[id]) {
        return this.$data.predicts[id][country]
      }
    }
  },
  created: function () {
    let Vue = this
    Predict.loadGames(Vue)
    Vue.timer = setInterval(function () {
      Predict.loadGames(Vue, true)
    }, 10000)
    PagesFunc.breadcrumbsJSON(this.$router.currentRoute.path, this.$t('pages.predict'))
  },
  beforeDestroy () {
    clearInterval(this.timer)
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/ResultsPredict/ResultsPredict.vue